import { useTranslation } from "react-i18next";
import { waLink } from "@/lib/links";

export default function WhatsAppFloat() {
  const { t } = useTranslation();

  return (
    <a
      href={waLink(t("wa.float"))}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("whatsappFloat")}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold pl-4 pr-5 py-3 rounded-full cursor-pointer whitespace-nowrap transition animate-floaty"
    >
      <span className="w-8 h-8 rounded-full bg-background-50/20 flex items-center justify-center">
        <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center" />
      </span>
      <span className="hidden sm:inline text-sm">{t("whatsappFloat")}</span>
    </a>
  );
}